export default "__VITE_ASSET__lBxCN40B__"